import { EboEmployeeEvent } from '../../base-classes/ebo-employee-event';
import { EntryType } from '../../shared/entry-type.enum';

export class EmployeePtoLedger extends EboEmployeeEvent {
  vacationBalanceOverride: number;
  vacationDelta: number;
  entryType: EntryType;

  constructor(data?: Partial<EmployeePtoLedger>) {
    super(data);
    this.entryType ??= EntryType.Automatic;
  }

  get summary(): string {
    if (this.vacationBalanceOverride !== undefined && this.vacationBalanceOverride !== null) {
      return `Balance Set: ${this.vacationBalanceOverride}`;
    }
    return `${this.vacationDelta} PTO ${this.vacationDelta > 0 ? 'Earned' : 'Used'}`;
  }
  set summary(value: string) {
    // Do nothing
  }
}
